/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Any_Bc_SyncInputs */

const en_filter_any_bc_sync = /** @type {(inputs: Filter_Any_Bc_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any Business Central status`)
};

/**
* | output |
* | --- |
* | "Any Business Central status" |
*
* @param {Filter_Any_Bc_SyncInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const filter_any_bc_sync = /** @type {((inputs?: Filter_Any_Bc_SyncInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Any_Bc_SyncInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filter_any_bc_sync(inputs)
});